module.exports = __webpack_public_path__ + "static/media/logoWSJ.b8d6b3ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/logoWSJ.svg
// module id = 190
// module chunks = 0